import { render, staticRenderFns } from "./ContentLighbox.vue?vue&type=template&id=cd5da0ec&scoped=true&"
import script from "./ContentLighbox.vue?vue&type=script&lang=ts&"
export * from "./ContentLighbox.vue?vue&type=script&lang=ts&"
import style0 from "./ContentLighbox.vue?vue&type=style&index=0&id=cd5da0ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5da0ec",
  null
  
)

export default component.exports